var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "picking-modal",
      attrs: { role: "presentation" },
      on: {
        mousedown: function ($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "section",
        {
          staticClass: "picking-dialog picking-dialog--form",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "picking-title",
          },
        },
        [
          _c("header", { staticClass: "picking-dialog__header" }, [
            _c("div", { staticClass: "picking-dialog__header-content" }, [
              _c("h2", { attrs: { id: "picking-title" } }, [
                _vm._v("Picklijst " + _vm._s(_vm.picking.code)),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "picking-dialog__header-meta",
                  class: {
                    "picking-dialog__header-meta--without-order-info":
                      !_vm.hasOrderInfo,
                  },
                },
                [
                  _c("div", { staticClass: "picking-dialog__meta-group" }, [
                    _c("span", { staticClass: "picking-dialog__meta-title" }, [
                      _vm._v("Bestelling"),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("i", { staticClass: "ak-icon" }, [
                        _vm._v("receipt_long"),
                      ]),
                      _vm._v("\n                            Ordernummer: "),
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.$emit("open-order")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.picking.orderCode))]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.picking.externalOrderId
                      ? _c("p", [
                          _c("i", { staticClass: "ak-icon" }, [
                            _vm._v("confirmation_number"),
                          ]),
                          _vm._v(
                            " Extern ordernummer: " +
                              _vm._s(_vm.picking.externalOrderId)
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "picking-dialog__meta-group" }, [
                    _c("span", { staticClass: "picking-dialog__meta-title" }, [
                      _vm._v("Klant"),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("i", { staticClass: "ak-icon" }, [
                        _vm._v("person_outline"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.picking.customerName)),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("i", { staticClass: "ak-icon" }, [_vm._v("near_me")]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.picking.address) +
                          "\n                            "
                      ),
                      _vm.picking.hasSuspiciousShippingAddress
                        ? _c(
                            "i",
                            {
                              staticClass:
                                "ak-icon picking-dialog__address-warning",
                              attrs: {
                                title:
                                  "Controleer het leveringsadres: straatnaam en huisnummer lijken verwisseld of dubbel ingevuld.",
                                "aria-label":
                                  "Controleer het leveringsadres: straatnaam en huisnummer lijken verwisseld of dubbel ingevuld.",
                              },
                            },
                            [_vm._v("warning")]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.hasOrderInfo
                    ? _c(
                        "section",
                        {
                          staticClass:
                            "picking-order-info picking-dialog__meta-group",
                          attrs: { "aria-label": "Orderinformatie" },
                        },
                        [
                          _vm.picking.requestedDeliveryDate
                            ? _c(
                                "div",
                                { staticClass: "picking-order-info__item" },
                                [
                                  _c("span", [_vm._v("Gewenste leverdatum")]),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.picking.requestedDeliveryDate)
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.picking.externalComments
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "picking-order-info__item picking-order-info__comments",
                                },
                                [
                                  _c("span", [
                                    _vm._v("Opmerkingen van de klant"),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.picking.externalComments)
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "picking-dialog__close",
                attrs: { type: "button", "aria-label": "Sluiten" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_c("i", { staticClass: "ak-icon" }, [_vm._v("close")])]
            ),
          ]),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "picking-dialog__body",
              attrs: { id: "picking-v2-form" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "picking-dialog__intro" }, [
                _c("div", { staticClass: "picking-field" }, [
                  _c("label", { attrs: { for: "picker-name" } }, [
                    _vm._v("Naam orderpicker *"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.pickerName,
                        expression: "form.pickerName",
                      },
                    ],
                    ref: "pickerName",
                    class: { "is-invalid": _vm.fields.pickerName },
                    attrs: { id: "picker-name" },
                    domProps: { value: _vm.form.pickerName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form, "pickerName", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.fields.pickerName
                    ? _c("small", [_vm._v(_vm._s(_vm.fields.pickerName))])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "picking-field" }, [
                  _c("label", { attrs: { for: "picking-remarks" } }, [
                    _vm._v("Interne opmerkingen picking"),
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.remarks,
                        expression: "form.remarks",
                      },
                    ],
                    attrs: {
                      id: "picking-remarks",
                      rows: "1",
                      placeholder: "Typ hier…",
                    },
                    domProps: { value: _vm.form.remarks },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form, "remarks", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "picking-dialog__columns",
                  class: {
                    "picking-dialog__columns--without-order-lines":
                      !_vm.form.items.length,
                  },
                },
                [
                  _c("section", [
                    _vm.form.items.length
                      ? _c("h3", [_vm._v("Bestelling")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.form.items.length
                      ? _c(
                          "div",
                          { staticClass: "picking-lines" },
                          _vm._l(_vm.form.items, function (item) {
                            return _c(
                              "article",
                              { key: item.id, staticClass: "picking-line" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "picking-line__name" },
                                  [
                                    _c("span", [_vm._v(_vm._s(item.title))]),
                                    _vm._v(" "),
                                    _c("small", [
                                      _vm._v("#" + _vm._s(item.code)),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("counter-control", {
                                  attrs: {
                                    value: item.picked,
                                    maximum: item.maximumPickable,
                                    display: item.picked + "/" + item.requested,
                                  },
                                  on: {
                                    input: function ($event) {
                                      item.picked = $event
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.fields["items." + item.id]
                                  ? _c(
                                      "small",
                                      { staticClass: "picking-line__error" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.fields["items." + item.id]
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "section",
                      {
                        staticClass: "picking-shipping",
                        class: {
                          "picking-shipping--without-order-lines":
                            !_vm.form.items.length,
                        },
                      },
                      [
                        _c("h3", [_vm._v("Verzending")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "picking-shipping__option",
                            class: {
                              "picking-shipping__option--disabled":
                                _vm.isOtherDelivery,
                            },
                            attrs: { "aria-disabled": _vm.isOtherDelivery },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "picking-shipping__row" },
                              [
                                _c(
                                  "span",
                                  { attrs: { id: "bpost-labels-label" } },
                                  [_vm._v("Aantal Bpost-labels")]
                                ),
                                _vm._v(" "),
                                _c("counter-control", {
                                  attrs: {
                                    "aria-labelledby": "bpost-labels-label",
                                    value: _vm.form.shipping.numberOfBoxes,
                                    display:
                                      _vm.form.shipping.numberOfBoxes || "–",
                                    disabled: _vm.isOtherDelivery,
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.setNumberOfBoxes($event)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.fields["shipping.numberOfBoxes"]
                              ? _c(
                                  "small",
                                  { staticClass: "picking-shipping__error" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.fields["shipping.numberOfBoxes"]
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.form.shipping.numberOfBoxes > 0
                              ? _c(
                                  "div",
                                  { staticClass: "picking-shipping__type" },
                                  [
                                    _c(
                                      "label",
                                      { attrs: { for: "box-type" } },
                                      [_vm._v("Bpost-pakkettype *")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.form.shipping.boxType,
                                            expression: "form.shipping.boxType",
                                          },
                                        ],
                                        attrs: { id: "box-type", required: "" },
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.form.shipping,
                                              "boxType",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: { disabled: "", value: "" },
                                          },
                                          [_vm._v("Kies een Bpost-pakkettype")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.form.shipping.boxTypes,
                                          function (type) {
                                            return _c(
                                              "option",
                                              {
                                                key: type,
                                                domProps: { value: type },
                                              },
                                              [_vm._v(_vm._s(type))]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.fields["shipping.boxType"]
                              ? _c(
                                  "small",
                                  { staticClass: "picking-shipping__error" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.fields["shipping.boxType"])
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.form.shipping.numberOfBoxes > 0
                              ? _c(
                                  "div",
                                  { staticClass: "picking-shipping__weight" },
                                  [
                                    _c(
                                      "label",
                                      { attrs: { for: "shipment-weight" } },
                                      [_vm._v("Totaal gewicht verzending")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "picking-shipping__weight-input",
                                      },
                                      [
                                        _c("input", {
                                          ref: "shipmentWeight",
                                          class: {
                                            "is-invalid":
                                              _vm.weightError ||
                                              _vm.fields[
                                                "shipping.shipmentWeightInGrams"
                                              ],
                                          },
                                          attrs: {
                                            id: "shipment-weight",
                                            type: "text",
                                            inputmode: "decimal",
                                            pattern: "[0-9]+(,[0-9]{1,3})?",
                                            title:
                                              "Gebruik alleen cijfers en een komma, met maximaal drie decimalen.",
                                          },
                                          domProps: {
                                            value: _vm.weightInputDirty
                                              ? _vm.weightInputValue
                                              : _vm.totalWeight,
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.validateShipmentWeightInput(
                                                $event.target
                                              )
                                            },
                                            change: function ($event) {
                                              return _vm.setShipmentWeight(
                                                $event.target
                                              )
                                            },
                                            focus: function ($event) {
                                              return $event.target.select()
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("kg")]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("small", [
                                      _vm._v(
                                        "Gebruik een komma voor decimalen, bijvoorbeeld 02,500 kg."
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm.weightError ||
                                    _vm.fields["shipping.shipmentWeightInGrams"]
                                      ? _c(
                                          "small",
                                          {
                                            staticClass:
                                              "picking-shipping__error",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.weightError ||
                                                  _vm.fields[
                                                    "shipping.shipmentWeightInGrams"
                                                  ]
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "picking-shipping__option",
                            class: {
                              "picking-shipping__option--disabled":
                                _vm.isOtherDelivery,
                            },
                            attrs: { "aria-disabled": _vm.isOtherDelivery },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "picking-shipping__row" },
                              [
                                _c(
                                  "span",
                                  { attrs: { id: "envelopes-label" } },
                                  [_vm._v("Aantal enveloppen te frankeren")]
                                ),
                                _vm._v(" "),
                                _c("counter-control", {
                                  attrs: {
                                    "aria-labelledby": "envelopes-label",
                                    value: _vm.form.shipping.numberOfEnvelopes,
                                    display:
                                      _vm.form.shipping.numberOfEnvelopes ||
                                      "–",
                                    disabled: _vm.isOtherDelivery,
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.setNumberOfEnvelopes($event)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.fields["shipping.numberOfEnvelopes"]
                              ? _c(
                                  "small",
                                  { staticClass: "picking-shipping__error" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.fields["shipping.numberOfEnvelopes"]
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass:
                              "picking-shipping__option picking-shipping__row picking-shipping__row--other",
                          },
                          [
                            _c("span", [
                              _vm._v("Andere levering (bv. pallet of afhalen)"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              staticClass: "picking-shipping__switch",
                              attrs: { type: "checkbox" },
                              domProps: { checked: _vm.isOtherDelivery },
                              on: {
                                change: function ($event) {
                                  return _vm.setOtherDelivery(
                                    $event.target.checked
                                  )
                                },
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("section", [
                    _c("h3", [_vm._v("Kies verpakking")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "picking-lines" },
                      _vm._l(_vm.orderedMaterials, function (material) {
                        return _c(
                          "article",
                          {
                            key: material.id,
                            staticClass: "picking-line picking-line--material",
                            class: { "is-addable": material.amount === 0 },
                            on: {
                              click: function ($event) {
                                return _vm.addMaterial(material)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "picking-line__name" }, [
                              _c("span", [_vm._v(_vm._s(material.title))]),
                            ]),
                            _vm._v(" "),
                            _c("counter-control", {
                              attrs: {
                                value: material.amount,
                                display: material.amount || "–",
                                editable: "",
                              },
                              on: {
                                input: function ($event) {
                                  material.amount = $event
                                },
                              },
                              nativeOn: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                },
                              },
                            }),
                            _vm._v(" "),
                            _vm.fields["materials." + material.id]
                              ? _c(
                                  "small",
                                  { staticClass: "picking-line__error" },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.fields["materials." + material.id]
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.fields.picking
                ? _c(
                    "p",
                    {
                      staticClass: "picking-dialog__error",
                      attrs: { role: "alert" },
                    },
                    [_vm._v(_vm._s(_vm.fields.picking))]
                  )
                : _vm.error
                ? _c(
                    "p",
                    {
                      staticClass: "picking-dialog__error",
                      attrs: { role: "alert" },
                    },
                    [_vm._v(_vm._s(_vm.error))]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("footer", { staticClass: "picking-dialog__footer" }, [
            _c(
              "button",
              {
                staticClass: "picking-button picking-button--text",
                attrs: { type: "button", disabled: _vm.saving },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_vm._v("Annuleren")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "picking-button picking-button--primary",
                attrs: {
                  type: "submit",
                  form: "picking-v2-form",
                  disabled:
                    _vm.saving ||
                    (!_vm.hasActualPickingChange && !_vm.weightInputDirty),
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.saving ? "Opslaan…" : "Opslaan") +
                    "\n            "
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }